module.exports = __webpack_public_path__ + "media/images/chosen-sprite-6768c1976c2ad78da1634b00b1e84dc2.png";